/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S4_P1Inputs */

const en_guide_what_is_json_s4_p1 = /** @type {(inputs: Guide_What_Is_Json_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON is incredibly versatile. Here are the most common scenarios where you'll encounter JSON in real-world development:`)
};

const ko_guide_what_is_json_s4_p1 = /** @type {(inputs: Guide_What_Is_Json_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON은 매우 다양하게 활용됩니다. 실제 개발에서 JSON을 접하게 되는 가장 일반적인 시나리오는 다음과 같습니다:`)
};

const ja_guide_what_is_json_s4_p1 = /** @type {(inputs: Guide_What_Is_Json_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONは非常に汎用的です。以下は、実際の開発でJSONに遭遇する最も一般的なシナリオです：`)
};

/**
* | output |
* | --- |
* | "JSON is incredibly versatile. Here are the most common scenarios where you'll encounter JSON in real-world development:" |
*
* @param {Guide_What_Is_Json_S4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s4_p1 = /** @type {((inputs?: Guide_What_Is_Json_S4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s4_p1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s4_p1(inputs)
	return ja_guide_what_is_json_s4_p1(inputs)
});